export const ruffTimeView = () => ({
  type: 'Views loading error page',
});

export const userViewsLoadingScreen = () => ({
  type: '[Sampler Box] User views loading screen',
});
